module.exports = __webpack_public_path__ + "static/media/responseBtnEng.86f3f036.png";